import React from 'react';

const NoPrivilege: React.FC = () => {

  return (
      <div style={{
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, sans-serif',
        background: '#ffffff',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#333'
      }}>
        <div style={{
          textAlign: 'center',
          padding: '2rem',
          maxWidth: '600px'
        }}>
          <div style={{
            width: '80px',
            height: '80px',
            margin: '0 auto',
            position: 'relative'
          }}>
            <div style={{
              width: '35px',
              height: '35px',
              border: '8px solid #0073aa',
              borderRadius: '50% 50% 0 0',
              borderBottom: 'none',
              position: 'absolute',
              top: '-35px',
              left: '50%',
              transform: 'translateX(-50%)'
            }}></div>
            <div style={{
              width: '60px',
              height: '45px',
              background: '#0073aa',
              borderRadius: '5px',
              margin: '0 auto',
              position: 'relative'
            }}>
              <div style={{
                width: '6px',
                height: '15px',
                background: '#fff',
                borderRadius: '3px',
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)'
              }}>
                <div style={{
                  content: '""',
                  width: '12px',
                  height: '12px',
                  background: '#fff',
                  borderRadius: '50%',
                  position: 'absolute',
                  top: '-10px',
                  left: '50%',
                  transform: 'translateX(-50%)'
                }}></div>
              </div>
            </div>
          </div>

          <h1 style={{
            fontSize: '2rem',
            marginBottom: '0.5rem',
            color: '#0073aa',
            fontWeight: 600
          }}>Access Denied</h1>
          
          <div style={{
            fontSize: '1rem',
            color: '#666',
            marginBottom: '1.5rem'
          }}>Error 403 - No Privilege</div>
          
          <p style={{
            fontSize: '1rem',
            lineHeight: '1.5',
            marginBottom: '1.5rem',
            color: '#555'
          }}>
            You do not have the necessary authorisation to access this resource.
          </p>
        </div>
</div>
  );
};

export default NoPrivilege;